<template>
  <div class="feedback">
    <van-nav-bar
      title="帮助与反馈"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      v-model="content"
      rows="4"
      autosize
      type="textarea"
      maxlength="200"
      placeholder="说说你的问题，上传截图问题解决得更快哦~"
      show-word-limit
    />
    <div class="uploader_area">
      <van-uploader
        v-model="fileList"
        multiple :max-count="3"
        :preview-size="106" 
        :after-read="upload"
        :before-delete="beforeDelete"
      />
    </div>
    <div class="submits">
      <van-button type="primary" :disabled="!content.length > 0" @click="doFeedback">发送</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Field, Uploader, Button, Toast} from 'vant'
Vue.use(NavBar).use(Field).use(Uploader).use(Button).use(Toast)

export default {
  data() {
    return {
      content: '',
      images: [],
      fileList: []
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    doFeedback: function() {
      let param  = new FormData()
      param.append('userid', this.getCookie('userid'))
      param.append('app_version', this.getCookie('app_version'))
      param.append('soft_id', this.getCookie('soft_id'))
      param.append('site_id', this.getCookie('site_id'))
      param.append('content', this.content)
      param.append('images', this.images)

      this.$http.post('/api/user_web/feedback', param).then(() => {
        Toast.success('提交成功')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
    },
    upload: function(file) {
      file.status = 'uploading'
      file.message = '上传中...'

      let img = new Image()
      img.src = file.content

      img.onload = () => {
        // 压缩图片
        let limitWidth = 320
        let width = img.width > limitWidth? limitWidth : img.width
        let height = img.width > limitWidth? parseInt((img.height * limitWidth) / img.width) : img.height
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        canvas.width = width
        canvas.height = height
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, width, height)          
        let url = canvas.toDataURL('image/jpeg')

        // 将base64转file对象
        let filename = 'file'
        let params = url.split(',')
        let mime = params[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(params[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        let compress = new File([u8arr], `${filename}.${suffix}`, {type: mime})
        let param  = new FormData()
        param.append('images', compress)

        this.$http.post('/api/user_web/upload', param).then((res) => {
          if (res.code == 1) {
            this.images.push(res.data.images)
            file.status = 'done'
            file.message = ''
          } else {
            file.status = 'failed'
            file.message = '上传失败'
          }
        })
      }
    },
    beforeDelete: function(_, detail) {
      this.images.splice(detail.index, 1)      
      return true
    },
    onClickLeft: function () {
      this.$router.push({path: '/help'})
    }
  }
}
</script>

<style lang="less" scoped>
  .feedback {
    display: block;
    width: 100%;
    max-width: 3.75rem;
    max-height: 100vh;
    overflow: hidden;

    .uploader_area {
      display: block;
      width: calc(100% - .32rem);
      margin: 0 auto;
      margin-top: .32rem;
    }

    .submits {
      display: block;
      width: 3.75rem;
      height: .48rem;
      position: absolute;
      bottom: .16rem;
      margin: 0 auto;
      overflow: hidden;

      button {
        display: block;
        width: 3.45rem;
        height: .48rem;
        margin: 0 auto;
      }
    }

    /deep/ .van-nav-bar{
      margin-top: .26rem;
    }
    /deep/.van-icon {
      color: #666666;
    }
    /deep/.van-nav-bar__title {
      font-size: 18px;
      color: #333333;
    }
  }
</style>